/**
 * Dependencies
 */
import { cloneDeep } from 'lodash'

/**
 * CAPEX modal state
 *
 * @type {Object}
 */
const state = {
    fresh: false,
    showModal: false,
    saving: false,
    form: {},
    errors: {},
    options: {
        amount_unit: [
            { key: 0, label: 'Total $ Amount' },
            { key: 1, label: '$ per SQFT' },
            { key: 2, label: '$ per Unit' },
            { key: 3, label: '% of Project Costs' },
            { key: 4, label: '% of Acquisition Costs' },
            { key: 5, label: '% of Hard Costs' },
            { key: 6, label: '% of Soft Costs' },
            { key: 7, label: '% of Financing Costs' },
            { key: 8, label: '% of Custom Group' }
        ],
        dep_type: [
            { key: 'LC', label: 'Land' },
            { key: 'BC', label: 'Buildings' },
            { key: 'LI', label: 'Land Improvement' },
            { key: 'PP', label: 'Personal Property' }
        ]
    },
    existingContext: {
        serializer: null,
        index: null
    },
    currentTab: 'general'
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/projects/form/capex/state.js